







































import { Component, Mixins } from "vue-property-decorator";
import GameMixin, { GameInterface } from "@/components/GameMixins.vue";
import Undo from "@/components/shared/Undo.vue";
import Trashcan from "@/components/shared/Trashcan.vue";
import {
  LoadWords,
  wordElement,
  findCorrectAndWrongSolutions,
} from "@/components/words/Words";

@Component<Remove>({
  components: {
    Trashcan,
    Undo,
  },
})
export default class Remove extends Mixins(GameMixin) implements GameInterface {
  word: wordElement[] = null;
  similarWords: string[] = null;
  selected: number = null;
  charRemoved = false;
  animationSteps: Array<string> = null;

  isInitialized(): boolean {
    return this.word !== null;
  }

  start() {
    [this.word, this.similarWords] = LoadWords("remove", 1);
    this.selected = null;
    this.charRemoved = false;
    this.animationSteps = this.getAnimationSteps();
  }

  isCorrect(): boolean {
    return this.similarWords.includes(this.word.map((el) => el.char).join(""));
  }

  trashElement() {
    if (this.charRemoved) {
      return;
    }
    this.word.forEach((el) => {
      if (el.id === this.selected) {
        el.char = "";
      }
      el.locked = true;
    });
    this.charRemoved = true;
  }

  undo() {
    this.word.forEach((el) => {
      el.char = el.initialChar;
      el.locked = false;
    });
    this.selected = null;
    this.charRemoved = false;
  }

  getAnimationSteps(): Array<string> {
    const [correctPos, , wrongPos, ,] = findCorrectAndWrongSolutions(
      this.word.map((el) => el.char).join(""),
      this.similarWords[0]
    );
    return new Array<string>(
      `word-char-${wrongPos}`,
      "trashcan",
      "button-menu-check",
      "undo",
      `word-char-${correctPos}`,
      "trashcan",
      "button-menu-check",
      "button-menu-next"
    );
  }
}
